import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const ABWTOFNE_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/abwtofne/logo.png",
        alt: "A Better Way Therapy Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 21,
  state: "NE",
  departmentIds: [116, 472, 473, 474, 475, 476, 499],
};
